import { TLineString } from '@/shared/types/geojson';
import { ComputedMarker } from '@/shared/types/zod';
import angle from "@turf/angle";
import bearing from "@turf/bearing";
import { degreesToRadians } from "@turf/helpers";
import { getLineIndex } from "@/utils/lineSampling";
import { firstProgress } from "@/utils/markerProgress";

export const SMALL_MARKER_SIZE = .62;
export const SMALL_MARKER_ZOOM = 7;
export const MID_MARKER_ZOOM = 20;
export const MID_MARKER_SIZE = .8;
export const LARGE_MARKER_ZOOM = 22;
export const LARGE_MARKER_SIZE = 1.1;

export const BASE_IMAGE_WIDTH = 100;

export function setRouteAngle(route: TLineString, marker: ComputedMarker, actualTrackLength: number) {

	const location = firstProgress(marker.properties.__progress, 0) * actualTrackLength;
	const index = getLineIndex(route.geometry);
	const point = index.sampleFeatureAtDistance(location)
	// const point = nearestPointOnLine(route.geometry, marker.geometry);

	// if ((point.properties.dist ?? Infinity) < 15 / 1000 && !marker.properties.__generated && point.properties.location) {
	const point1 = index.sampleFeatureAtDistance(Math.max(0, location - 2 / 1000));
	const point2 = index.sampleFeatureAtDistance(location + 2 / 1000);
	const ang = angle(point.geometry, point2.geometry, marker.geometry) - 180
	marker.properties.__angle = degreesToRadians(bearing(point1, point2) + (ang < 0 ? 180 : 0));

	// } else {
	// 	return undefined
	// }
}


export function dropShadow(context: CanvasRenderingContext2D) {
	context.shadowColor = "#000000bb";
	context.shadowOffsetX = 2;
	context.shadowOffsetY = 2;
	context.shadowBlur = 5;
}

export function addRoundRectPath(
	context: CanvasRenderingContext2D,
	x: number,
	y: number,
	width: number,
	height: number,
	radius: number,
) {
	const safeRadius = Math.max(0, Math.min(radius, width / 2, height / 2));
	const roundRect = (context as any).roundRect as ((x: number, y: number, width: number, height: number, radius: number) => void) | undefined;
	if (typeof roundRect === "function") {
		roundRect.call(context, x, y, width, height, safeRadius);
		return;
	}

	context.moveTo(x + safeRadius, y);
	context.lineTo(x + width - safeRadius, y);
	context.arcTo(x + width, y, x + width, y + safeRadius, safeRadius);
	context.lineTo(x + width, y + height - safeRadius);
	context.arcTo(x + width, y + height, x + width - safeRadius, y + height, safeRadius);
	context.lineTo(x + safeRadius, y + height);
	context.arcTo(x, y + height, x, y + height - safeRadius, safeRadius);
	context.lineTo(x, y + safeRadius);
	context.arcTo(x, y, x + safeRadius, y, safeRadius);
	context.closePath();
}